export interface Options {
  prefix: string;
  decimal: string;
  precision: number;
  disableNegative: boolean;
  disabled: boolean;
  min: number | string | null;
  max: number | string | null;
  allowBlank: boolean;
  minimumNumberOfCharacters: number;
  roundToMaxValue: boolean;
  roundToMinValue: boolean;
  focusOnRight: boolean;
  lazy: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export default {
  prefix: '',
  precision: 2,
  disableNegative: false,
  disabled: false,
  min: null,
  max: null,
  allowBlank: false,
  minimumNumberOfCharacters: 0,
  focusOnRight: false,
  lazy: true,
} as Options;
